<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0" style="white-space: nowrap">
        <v-select
          v-if="!options.hideProjectSelector && !options.projectSearch"
          v-model="project"
          :class="{'report-base-filter': !options.multiple, 'report-multiple-combobox': options.multiple}"
          :items="projectListWithAll"
          :multiple="options.multiple"
          hide-details
          label="Project"
          single-line
          style="min-width: 200px; max-width: 230px"
          clearable
        />
        <v-autocomplete
          v-if="!options.hideProjectSelector && options.projectSearch"
          v-model="project"
          :class="{'report-base-filter': !options.multiple, 'report-multiple-combobox': options.multiple}"
          :items="projectListWithAll"
          :multiple="options.multiple"
          auto-select-first
          hide-details
          label="Project"
          single-line
          style="min-width: 200px"
        />
        <v-btn
          v-text="'Search'"
          :disabled="loading"
          :loading="loading"
          class="mt-2 ml-2"
          color="info"
          @click="search"
        />
        <v-checkbox
          v-model="isTableDisplayed"
          class="ml-2 mt-0 align-center"
          label="Show table"
          hide-details
        />
      </v-row>
    </v-card>
    <v-card class="col-12 pt-4 pb-4 px-0 mt-4">
      <div id="choropleth" ref="choropleth" />
    </v-card>

    <v-card v-if="isTableDisplayed">
      <v-data-table
        :items="items"
        :headers="headers"
      >
        <template #item.top_project="{ item }">
          {{ queryAll && projectNameById[item.top_project.entity_id] || '-' }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { get } from 'lodash'
import { API } from '@/utils/api'
import Plotly from 'plotly.js-dist-min'

const data = [{
  type: 'choropleth',
  locations: [],
  z: [],
  hovertext: [],
  customdata: [],
  colorscale: 'Viridis',
  colorbar: { title: 'Score' },
  hovertemplate: '<b>%{hovertext}</b><br>active_players=%{z}<br>top_performer=%{customdata}'
}]

const layout = {
  title: 'Choropleth Map Example',
  geo: {
      projection: { type: 'natural earth' }
  },
  margin: {
    t: 20,
    l: 20,
    r: 20,
    b: 20,
  }
}

export default {
  props: {
    title: {},
    headers: {},
    projectList: {
      default: () => ([])
    },
    filters: {},
    url: {},
    defaultParams: {
      default: () => ({})
    },
    nowrap: {
      default: true
    },
    table_size_fixed: {
      default: false
    },
    options: {
      default: () => ({})
    }
  },
  data() {
    return {
      project: null,
      loading: false,
      items: [],
      isTableDisplayed: false,
      queryAll: false,
    }
  },

  mounted() {
    this.renderMap()
  },

  computed: {
    projectListWithAll() {
      return [ { text: 'All', value: null }, ...this.projectList ]
    },
    projectNameById() {
      return this.projectList.reduce((acc, { text, value }) => {
        acc[value] = text
        return acc
      }, {})
    }
  },

  methods: {
    search: function () {
        this.loading = true
        try {
          API.call(this.url, {
            ...this.defaultParams,
            ...this.tableOptions,
          }, null, this.project).then(resp => {

            this.items = get(resp, 'data', [])
            this.queryAll = !this.project

            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },

      renderMap() {
        Plotly.newPlot(this.$refs.choropleth, data, layout)
      },
  },
  watch: {
    items: {
      handler(newItems) {
        data[0].locations = []
        data[0].z = []
        data[0].hovertext = []
        data[0].customdata = []
        data[0].hovertemplate = this.queryAll ? '<b>%{hovertext}</b><br>active_players=%{z}<br>top_performer=%{customdata}' : '<b>%{hovertext}</b><br>active_players=%{z}'

        for (const item of newItems) {
          data[0].locations.push(item.iso3)
          data[0].z.push(item.active_players)
          data[0].hovertext.push(item.country_name)
          data[0].customdata.push(this.projectNameById[item.top_project.entity_id] || '-')
        }
        Plotly.react(this.$refs.choropleth, data, layout)
      }
    }
  }
}
</script>
